import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import CatalogColor from './CatalogColor';
import { FormattedMessage } from "react-intl"
import { getColorsCards } from '../redux/actions/colorsActions'
import { ThreeDots } from 'react-loader-spinner'
import { Context } from '../components/context/LanguageWrapper';

const CatalogColorsList = () => {

  const dispatch = useDispatch();

  const context = useContext(Context)

  const userLogin = useSelector(state => state.userLogin)
  const { userDetails } = userLogin

  const colorsData = useSelector(state => state.optionsColors)
  const { loading, colors } = colorsData

  useEffect(() => {

    const headers = {
      headers: {
        "x-auth-token": userDetails.token,
        "x-language": context.locale.slice(0, 2),
      }
    };

    dispatch(getColorsCards(headers))

  }, [dispatch, context])



  return (
    <>
      <div className="flex flex-col gap-2 mr-8">
        <div className='font-bold text-lg text-green-900'>
          <FormattedMessage id="app.catalog.form.colors.title" defaultMessage="" />
        </div>

        {loading ? (
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#2f4d44"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        ) : !loading && colors && colors['data'].map((color, i) =>

          <CatalogColor key={i}
            color={color} />)}
      </div>
    </>
  )
}

export default CatalogColorsList